import { Box } from '@mui/material';
import { useState } from 'react';

import { Interest } from './Interest';
import { INTERESTS, ROLES } from '../IntroductionModal/introductionSteps.data';

export type TOnChangePayload = {
    user_type: string[];
    interest: string[];
};

interface IInterests {
    onChange: (val: TOnChangePayload) => void;
}

const Interests: React.FC<IInterests> = ({ onChange }) => {
    const [selections, setSelections] = useState<TOnChangePayload>({
        user_type: [],
        interest: [],
    });

    const handleInterestChange = (selected: string[]) => {
        const updated = { ...selections, interest: selected };
        setSelections(updated);
        onChange(updated);
    };

    const handleRoleChange = (selected: string[]) => {
        const updated = { ...selections, user_type: selected };
        setSelections(updated);
        onChange(updated);
    };

    return (
        <Box
            sx={{
                width: '100%',
                minHeight: '600px',
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
            }}>
            <Interest header="What Interests You?" options={INTERESTS} onChange={handleInterestChange} />
            <Interest
                header="How Can we address You?"
                options={ROLES}
                sx={{ marginBottom: 2 }}
                onChange={handleRoleChange}
            />
        </Box>
    );
};

export { Interests };
